
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Container, Form} from "reactstrap";
import ContactService from "../../../services/contactService";
import ContactForm from "./Form";
import {contactRole} from "../../../util/contactRole";
import _ from "lodash";
import CompanyService   from "../../../services/companyService";
import UtilService from "../../../services/utilService";

class ContactCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            selectKey: UtilService.uuidv4(),
            companyUniqueId : this.props.match.params.uniqueId || null
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleContactRoleChange = this.handleContactRoleChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
    }

    async componentDidMount() {
        CompanyService.list().then(response => {
            this.setState({allCompanies: response});
            this.setState({selectKey: UtilService.uuidv4()});
            if(this.state.companyUniqueId !== null){
                const selectedCompany = _.find(this.state.allCompanies, company => company.uniqueId === this.state.companyUniqueId)
                this.setState({selectedCompany: selectedCompany, companyId : selectedCompany.uniqueId})
                this.setState({selectKey: UtilService.uuidv4()});
            }
        })

    }



    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }



    handleSubmit(event) {
        event.preventDefault();
        ContactService.create(this.state).then(response => {
            if (response.responseStatus === "SUCCESS") {
                this.props.history.push("/crm/contact/list");
            } else {
                this.setState({errorData: response.data});
                console.error("Error    ==>     " + response.message);
            }
        });
    }


    handleContactRoleChange(valueObj) {
        if (_.isNull(valueObj)) {
            this.setState({selectedContactRole: {}, category: ""});
        } else {
            this.setState({selectedContactRole: valueObj, contactRole: valueObj.key});
        }
    }

    handleCompanyChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({selectedCompany: {}, companyId :""});
        } else {
            this.setState({selectedCompany: valueObj, companyId : valueObj.uniqueId});
        }
    };

    render() {
        return (
            <>
                <SimpleHeader
                    name="Create"
                    parentName="Contact"
                    heading="XareGrowth"
                    newBtnUrl="/crm/contact/list"
                    newBtnText="List Contacts"
                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Create Contact</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <ContactForm
                                    selectKey={this.state.selectKey}
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                    isEdit={false}
                                    onContactRoleChange={this.handleContactRoleChange}
                                    selectedContact={this.state.selectedContactRole}
                                    contactRoles={contactRole}
                                    onCompanyChange={this.handleCompanyChange}
                                    selectedCompany={this.state.selectedCompany}
                                    companies={this.state.allCompanies}

                                />
                                <div className="text-center">
                                    <Button className="my-4" color="default" outline type="submit">
                                        Submit
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default ContactCreate;
